// Prices shown on the site for a roadmap session. The amount actually charged
// is set on the server (SESSION_PRICE_PAISE in server/routes/sessionBookings.js),
// so change both together. Set the list price higher than the price to show a
// struck-through discount again. Coupons (e.g. MERIT2000) are applied at checkout.
export const SESSION_LIST_PRICE_INR = 2000;
export const SESSION_PRICE_INR = 2000;
export const SESSION_HAS_DISCOUNT = SESSION_LIST_PRICE_INR > SESSION_PRICE_INR;

export const SESSION_DISCOUNT_PERCENT = Math.round((1 - SESSION_PRICE_INR / SESSION_LIST_PRICE_INR) * 100);

// ₹2,000 style, with Indian digit grouping
export const formatInr = (amount) => `₹${amount.toLocaleString('en-IN')}`;
